import { useQuery } from "@tanstack/react-query";
import type { ContractAlertTargetResource } from "@/interfaces";
import { axiosInstance } from "@follosoft/react-components";

export function useContractAlertTargets(contractId?: number | string) {
  return useQuery<ContractAlertTargetResource[]>({
    queryKey: ["contract-alert-targets", Number(contractId)],
    queryFn: async () => {
      if (!contractId) return [];

      const res = await axiosInstance().get(
        `/folloportal/contract-alert-targets?filter[contract_id]=${contractId}`
      );

      return res.data.data;
    },
    enabled: !!contractId,
    staleTime: 0,
  });
}
